import { definePartner } from "../definePartner";

/**
 * mLoyal: codes only: the coupon check validates them and the save exercises them.
 *
 * The app has no conversation of its own with it yet: every conversation field is the baseline's,
 * exactly as before it had a folder (R2.2 changed no behaviour). A gap between what the backend
 * offers and what the app does is asked when R2.4 builds the partner steps (DISCOUNT_V2_PLAN.md §9.12).
 */
export default definePartner("mloyal", {
  name: "mLoyal",
  backend: {
    listsOffers: false,
    appliesOffers: false,
    applyOtp: "none",
    takesTypedCodes: true,
    releaseNeeds: [],
    exercisedAtSave: true,
  },
});
